import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

const COLLAPSED_CLASS = 'components--ui--pages--primary-nav--collapsed'

export default class extends Controller {
  static targets = ['navLinks', 'navLinksCollapsed']
  static values = { updateUrl: String }
  connect() {
    this.currentScrollTop = 0
    this.navLinksTarget.addEventListener('scroll', this.navLinksScrollHandler);
    this.navLinksCollapsedTarget.addEventListener('scroll', this.navLinksScrollHandler)
  }

  disconnect() {
    this.navLinksTarget.removeEventListener('scroll', this.navLinksScrollHandler);
    this.navLinksCollapsedTarget.removeEventListener('scroll', this.navLinksScrollHandler)
  }

  navLinksScrollHandler = (e) => {
    this.currentScrollTop = e.target.scrollTop
  }

  collapse = () => {
    this.element.classList.add(COLLAPSED_CLASS)
    this.navLinksCollapsedTarget.scrollTop = this.currentScrollTop
    this.updateNavState(true)
  }

  expand = () => {
    this.element.classList.remove(COLLAPSED_CLASS)
    this.navLinksTarget.scrollTop = this.currentScrollTop
    this.updateNavState(false)
  }

  async updateNavState(collapsed) {
    if (!this.hasUpdateUrlValue) return

    const url = new URL(this.updateUrlValue, window.location.origin)
    url.searchParams.set('collapsed', collapsed)

    const request = new FetchRequest('PATCH', url.toString(), {
      responseKind: 'json'
    })

    await request.perform()
  }
}
